import { Calendar, I18nProvider } from '@heroui/react'
import { CalendarDate } from '@internationalized/date'

import { DriverAutocomplete } from '@/components/common/DriverAutocomplete'
import type { Driver } from '@/types/driver'

interface TimesheetFiltersProps {
  driverID?: string;
  onDriverChange: (id: string) => void;
  year?: number;
  month?: number;
  onPeriodChange: (year: number, month: number) => void;
}

export function TimesheetFilters({
  driverID,
  onDriverChange,
  year,
  month,
  onPeriodChange,
}: TimesheetFiltersProps) {
  
  const currentYear = new Date().getFullYear()
  const currentMonth = new Date().getMonth() + 1
  
  const focusDate = new CalendarDate(year || currentYear, month || currentMonth, 1)

  const handleFocusChange = (date: CalendarDate) => {
    onPeriodChange(date.year, date.month)
  }

  const handleDriverChange = (d: Driver | null) => {
    onDriverChange(d?.ID ?? '')
  }

  return (
    <div className="w-[300px] flex-shrink-0 bg-content1 p-4 flex flex-col items-center gap-4 rounded-large shadow-small">
      <div className="w-full">
        <DriverAutocomplete
          selectedId={driverID}
          onSelectionChange={handleDriverChange}
        />
      </div>

      <I18nProvider locale="ru-RU">
        <Calendar
          aria-label="Event date"
          focusedValue={focusDate}
          onFocusChange={handleFocusChange}
          minValue={new CalendarDate(2026, 1, 1)}
        >
          <Calendar.Header>
            <Calendar.NavButton className="text-foreground" slot="previous" />
            <Calendar.YearPickerTrigger className="w-full justify-center">
              <Calendar.YearPickerTriggerHeading className="text-foreground" />
              <Calendar.YearPickerTriggerIndicator className="text-foreground" />
            </Calendar.YearPickerTrigger>
            <Calendar.NavButton className="text-foreground" slot="next" />
          </Calendar.Header>
          <Calendar.Grid className="pointer-events-none opacity-80">
            <Calendar.GridHeader>
              {day => <Calendar.HeaderCell>{day}</Calendar.HeaderCell>}
            </Calendar.GridHeader>
            <Calendar.GridBody>
              {date => (
                <Calendar.Cell date={date}>
                  {({formattedDate}) => (
                    <div className="relative flex items-center justify-center w-full h-full">
                      {formattedDate}
                    </div>
                  )}
                </Calendar.Cell>
              )}
            </Calendar.GridBody>
          </Calendar.Grid>
          <Calendar.YearPickerGrid>
            <Calendar.YearPickerGridBody>
              {({year}) => <Calendar.YearPickerCell year={year} />}
            </Calendar.YearPickerGridBody>
          </Calendar.YearPickerGrid>
        </Calendar>
      </I18nProvider>
    </div>
  )
}
